(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-grid"]) return;
  try {
    
  (function () {
    const sectionRoot = document.querySelector('[data-section-id="{{ section.id }}"]');
    if (!sectionRoot) return;

    const main = sectionRoot.querySelector('.ec-layoutRole__main');
    const grid = sectionRoot.querySelector('[data-collection-grid]');
    const toggleBtn = sectionRoot.querySelector('.list_change_btn');
    const statusEl = sectionRoot.querySelector('[data-page-load-status]');
    const paginationEl = sectionRoot.querySelector('[data-collection-pagination]');
    let nextLink = paginationEl ? paginationEl.querySelector('[data-next-page]') : null;
    let loading = false;

    const initInview = () => {
      if (!grid) return;

      const items = grid.querySelectorAll('.ec-shelfGrid__item:nth-child(n+5)');
      if (!('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('inview'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('inview');
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -20% 0px' }
      );

      items.forEach((item) => observer.observe(item));
    };

    const appendNextPage = async () => {
      if (!nextLink || loading) return;

      loading = true;
      if (statusEl) statusEl.hidden = false;

      try {
        const response = await fetch(nextLink.href);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newItems = doc.querySelectorAll('[data-collection-grid] .ec-shelfGrid__item');

        newItems.forEach((item) => grid.appendChild(item));

        const newPagination = doc.querySelector('[data-collection-pagination] [data-next-page]');
        nextLink = newPagination;
        initInview();
      } catch (error) {
        console.error('Collection infinite scroll failed', error);
      } finally {
        loading = false;
        if (statusEl) statusEl.hidden = true;
      }
    };

    const initInfiniteScroll = () => {
      if (!nextLink) return;

      window.addEventListener(
        'scroll',
        () => {
          if (loading || !nextLink) return;
          const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
          if (scrollTop + clientHeight >= scrollHeight - 400) {
            appendNextPage();
          }
        },
        { passive: true }
      );
    };

    const initGridToggle = () => {
      if (!toggleBtn || !main) return;

      toggleBtn.addEventListener('click', () => {
        const width = window.innerWidth;

        if (width > 700) {
          main.classList.toggle('small');
          toggleBtn.classList.toggle('small');
          return;
        }

        if (main.classList.contains('small_sp')) {
          main.classList.remove('small_sp');
          toggleBtn.classList.remove('small_sp');
          main.classList.add('small_sp2');
          toggleBtn.classList.add('small_sp2');
        } else if (main.classList.contains('small_sp2')) {
          main.classList.remove('small_sp2');
          toggleBtn.classList.remove('small_sp2');
        } else {
          main.classList.add('small_sp');
          toggleBtn.classList.add('small_sp');
        }
      });
    };

    initInview();
    initInfiniteScroll();
    initGridToggle();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const drawerBtn = document.querySelector('.drawer_btn');
    const drawerBack = document.querySelector('.drawer_back');
    const drawerClose = document.querySelector('.drawer-close');
    const drawerBox = document.querySelector('.drawer_box');
    const body = document.body;

    if (!drawerBtn || !drawerBack || !drawerBox) return;

    function openDrawer() {
      body.classList.add('drawer_open');
      drawerBtn.setAttribute('aria-expanded', 'true');
    }

    function closeDrawer() {
      body.classList.remove('drawer_open');
      drawerBtn.setAttribute('aria-expanded', 'false');
    }

    drawerBtn.addEventListener('click', function (event) {
      event.preventDefault();
      if (body.classList.contains('drawer_open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    drawerBack.addEventListener('click', closeDrawer);
    if (drawerClose) drawerClose.addEventListener('click', closeDrawer);

    const menuLinks = document.querySelectorAll('.drawer-menu p a');
    menuLinks.forEach(function (link, index) {
      link.style.animationDelay = '0.' + (index * 2 + 20) + 's';
    });

    const openMenus = document.querySelectorAll('.drawer-menu .open-menu');
    openMenus.forEach(function (menu) {
      if (menu.classList.contains('detail_open')) {
        menu.style.height = menu.scrollHeight + 'px';
      } else {
        menu.style.height = '0';
      }
    });

    const menuBtns = document.querySelectorAll('.drawer-menu .menu-btn');
    menuBtns.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        const submenu = btn.nextElementSibling;
        if (!submenu) return;

        if (btn.classList.contains('detail_open')) {
          submenu.style.height = '0';
        } else {
          submenu.style.height = submenu.scrollHeight + 'px';
        }

        btn.classList.toggle('detail_open');
        submenu.classList.toggle('detail_open');
      });
    });

    window.addEventListener('load', function () {
      body.classList.add('load_end');
    });
    if (document.readyState === 'complete') {
      body.classList.add('load_end');
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ommo-product-row"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const syncHeadingHeights = (section) => {
      if (window.innerWidth <= 770) {
        section.querySelectorAll('.ec-secHeading, .ec-secHeading2').forEach((el) => {
          el.style.height = '';
          el.style.marginBottom = '';
        });
        return;
      }

      const image = section.querySelector('.uic-itemnew__image');
      const body = section.querySelector('.uic-itemnew__body');
      if (!image) return;

      const imageHeight = image.clientHeight;
      const bodyHeight = body ? body.clientHeight : 0;

      section.querySelectorAll('.ec-secHeading').forEach((el) => {
        el.style.height = `${imageHeight}px`;
      });

      section.querySelectorAll('.ec-secHeading2').forEach((el) => {
        el.style.height = `${imageHeight}px`;
        el.style.marginBottom = `${bodyHeight + 28}px`;
      });
    };

    const init = () => {
      document.querySelectorAll('[data-ommo-product-row-sync]').forEach(syncHeadingHeights);
    };

    window.addEventListener('load', init);
    window.addEventListener('resize', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omstore-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const carousels = document.querySelectorAll('[data-omstore-carousel]');

    carousels.forEach(function (root) {
      const slides = root.querySelectorAll('.main_slick__slide');
      if (slides.length === 0) {
        return;
      }

      slides[0].classList.add('is-active');

      if (slides.length === 1) {
        return;
      }

      const speed = parseInt(root.dataset.autoplay, 10) || 1500;
      let index = 0;

      window.setInterval(function () {
        slides[index].classList.remove('is-active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('is-active');
      }, speed);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function () {
    const sectionRoot = document.querySelector('[data-section-id="{{ section.id }}"]');
    if (!sectionRoot) return;

    const main = sectionRoot.querySelector('.ec-layoutRole__main');
    const grid = sectionRoot.querySelector('[data-search-grid]');
    const toggleBtn = sectionRoot.querySelector('.list_change_btn');
    const statusEl = sectionRoot.querySelector('[data-page-load-status]');
    const paginationEl = sectionRoot.querySelector('[data-search-pagination]');
    let nextLink = paginationEl ? paginationEl.querySelector('[data-next-page]') : null;
    let loading = false;

    const initInview = () => {
      if (!grid) return;

      const items = grid.querySelectorAll('.ec-shelfGrid__item:nth-child(n+5)');
      if (!('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('inview'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('inview');
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -20% 0px' }
      );

      items.forEach((item) => observer.observe(item));
    };

    const appendNextPage = async () => {
      if (!nextLink || loading || !grid) return;

      loading = true;
      if (statusEl) statusEl.hidden = false;

      try {
        const response = await fetch(nextLink.href);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newItems = doc.querySelectorAll('[data-search-grid] .ec-shelfGrid__item');

        newItems.forEach((item) => grid.appendChild(item));

        const newPagination = doc.querySelector('[data-search-pagination] [data-next-page]');
        nextLink = newPagination;
        initInview();
      } catch (error) {
        console.error('Search infinite scroll failed', error);
      } finally {
        loading = false;
        if (statusEl) statusEl.hidden = true;
      }
    };

    const initInfiniteScroll = () => {
      if (!nextLink) return;

      window.addEventListener(
        'scroll',
        () => {
          if (loading || !nextLink) return;
          const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
          if (scrollTop + clientHeight >= scrollHeight - 400) {
            appendNextPage();
          }
        },
        { passive: true }
      );
    };

    const initGridToggle = () => {
      if (!toggleBtn || !main) return;

      toggleBtn.addEventListener('click', () => {
        const width = window.innerWidth;

        if (width > 700) {
          main.classList.toggle('small');
          toggleBtn.classList.toggle('small');
          return;
        }

        if (main.classList.contains('small_sp')) {
          main.classList.remove('small_sp');
          toggleBtn.classList.remove('small_sp');
          main.classList.add('small_sp2');
          toggleBtn.classList.add('small_sp2');
        } else if (main.classList.contains('small_sp2')) {
          main.classList.remove('small_sp2');
          toggleBtn.classList.remove('small_sp2');
        } else {
          main.classList.add('small_sp');
          toggleBtn.classList.add('small_sp');
        }
      });
    };

    initInview();
    initInfiniteScroll();
    initGridToggle();
  })();

  } catch(e) { console.error(e); }
})();
})();
